import moment, { Moment } from 'moment';
import { EnumValues } from 'enum-values';

import { DateRangeKeyword } from './types';

export const parseKeywordToDateRange = (rangeKeyword: DateRangeKeyword): [Moment, Moment] => {
	switch (rangeKeyword) {
		case DateRangeKeyword.Today:
			return [moment().startOf('day'), moment().endOf('day')];
		case DateRangeKeyword.Tomorrow:
			return [moment().startOf('day').add(1, 'day'), moment().endOf('day').add(1, 'day')];
		case DateRangeKeyword.NextTwoDays:
			return [moment().startOf('day').add(1, 'day'), moment().endOf('day').add(3, 'day')];
		case DateRangeKeyword.LateOrders:
			return [moment().subtract(1, 'year'), moment()];
		case DateRangeKeyword.Last7Days:
			return [moment().startOf('day').subtract(6, 'days'), moment().endOf('day')];
		case DateRangeKeyword.Last30Days:
			return [moment().startOf('day').subtract(29, 'days'), moment().endOf('day')];
		case DateRangeKeyword.LastMonth:
			return [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
		default:
			console.warn(`Unknown date range keyword ${rangeKeyword}`);
			return [moment().startOf('day'), moment().endOf('day')];
	}
};

export const getSafeDateRange = (value: [string, string] | [Moment, Moment] | string): [Moment, Moment] => {
	let keyword = value;

	if (Array.isArray(value)) {
		const momentDates = value.map((date: string | Moment) => moment(date));

		if (momentDates.every(momentDate => momentDate.isValid())) {
			return momentDates as [Moment, Moment];
		} else {
			// It should be a string anyway at this point just to make TS happy
			keyword = String(value[0]);
		}
	}

	return parseKeywordToDateRange(keyword as DateRangeKeyword);
};

const KnownDateKeywords = new Set(EnumValues.getValues<string>(DateRangeKeyword));

export const isPairOfDateRangeKeywords = (value: unknown): value is [DateRangeKeyword, DateRangeKeyword] => {
	return Array.isArray(value) && value.length === 2 && value.every(v => KnownDateKeywords.has(v));
};
